import { motion } from 'framer-motion';
import React from 'react';

const Social = () => {
  const socialVariants = {
    hidden: { x: -20, opacity: 0 },
    visible: i => ({
      x: 0,
      opacity: 1,
      transition: {
        delay: i * 0.1,
        type: "spring",
        stiffness: 100
      }
    })
  };

  return (
    <div className="home__social">
      {[
        { icon: "uil-linkedin", url: "https://www.linkedin.com/in/alvin-ahmad-a137b1282/" },
        { icon: "uil-github-alt", url: "https://github.com/qalvinahmad" },
        { icon: "uil-dribbble", url: "https://dribbble.com/alvinahmad" },
        { icon: "uil-behance", url: "https://www.behance.net/alvinahmad" }
      ].map((item, index) => (
        <motion.a
          key={index}
          href={item.url}
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
          variants={socialVariants}
          custom={index}
          whileHover={{ y: -5, scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className={`uil ${item.icon}`}></i>
        </motion.a>
      ))}
    </div>
  );
};

export default Social;
